export const GIT_COMMIT = '70a61be46936daa7b354d2671538bb2bc6c55c76';
